import type { Reference } from "../../types/documentTypes";

export function extractReferences(
    data: Record<string, unknown>,
    existingReferences?: Map<string, Reference>
): Map<string, Reference> {
    const references = existingReferences ? new Map(existingReferences) : new Map<string, Reference>();

    for (const key in data) {
        if (key.endsWith("Reference")) {
            const fieldName = key.replace("Reference", "");
            references.set(fieldName, data[key] as Reference);
        }
    }

    return references;
}

export function extractReferencesFromMultiple(
    dataObjects: Array<Record<string, unknown> | undefined | null>,
    existingReferences?: Map<string, Reference>
): Map<string, Reference> {
    let references = existingReferences ? new Map(existingReferences) : new Map<string, Reference>();

    for (const data of dataObjects) {
        if (data) {
            references = extractReferences(data, references);
        }
    }

    return references;
}
